import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import { profileData } from "../data/ProfileData";

export const Profile = () => {
  return (
    <div className='profile-header'>
      <Container fluid>
        <Row>
          <Col lg='5' className='p-0 order-2 order-lg-1'>
            <div className='left-content lft-img'>
              <img src={profileData.image} alt='myimage' />
            </div>
          </Col>
          <Col lg='7' className='place order-1 order-lg-2'>
            <div className='right-content'>
              <h3>{profileData.designation}</h3>
              <h1>{profileData.name}</h1>
              <p>{profileData.description}</p>
              {isMobile && (
                <div className='left-content'>
                  <img src={profileData.image} alt='myimage' />
                </div>
              )}
              <div className='btn-section'>
                <Link to={profileData.CTA_link} className='mk-btn'>
                  {profileData.CTA_label}
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
